export default "__VITE_ASSET__YPN3AOON__"